export default __webpack_public_path__ + "static/media/2h.cbc1fb71.svg";